import React from 'react';
import {Image, View} from 'react-native';

import shareapp from '/asset/image/shareapp.png';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {androidLink, appStoreLink} from '../../ClientJourneyTask.util';
import {styles} from '../TaskDetails.style';

export const ShareOptaviaTaskDetails = (lastPaidRank: any) => {
  const {ts, tt} = useTranslation(
    'clientProfile.clientJourney.preJourney.shareOptaviaApp',
  );
  return (
    <>
      <View style={styles.preJourneyTaskDetailContent}>
        <Text
          variant="button"
          style={styles.taskDetailText}
          onPress={appStoreLink('external_link', lastPaidRank.lastPaidRank)}
          {...testProperties(DownlineProfile.cjTaskDetailsLink, true)}>
          {ts('appstorelink', 'Copy link to App Store (iPhone)')}
        </Text>
        <TouchableOpacity
          onPress={appStoreLink(
            'copy_external_link',
            lastPaidRank.lastPaidRank,
          )}
          {...testProperties(null, true)}>
          <Icon style={styles.copyIcon} name="copy" accessible={false} />
        </TouchableOpacity>
      </View>

      <View style={styles.preJourneyTaskDetailContent}>
        <Text
          variant="button"
          style={styles.taskDetailText}
          onPress={androidLink('external_link', lastPaidRank.lastPaidRank)}
          {...testProperties(DownlineProfile.cjTaskDetailsLink, true)}>
          {ts('googleplaylink', 'Copy link to Google Play Store (Android)')}
        </Text>
        <TouchableOpacity
          onPress={androidLink('copy_external_link', lastPaidRank.lastPaidRank)}
          {...testProperties(null, true)}>
          <Icon style={styles.copyIconAndroid} name="copy" accessible={false} />
        </TouchableOpacity>
      </View>
      <View style={styles.taskContentText}>
        {tt('shareAppContent', () => (
          <Text
            variant="button"
            style={styles.taskDetailContentShareApp}
            {...testProperties(DownlineProfile.cjTaskDetailsText)}>
            The goal of the <Text style={styles.optaText}>OPTA</Text> VIA App is
            to provide your Clients with key resources in one place while they
            are on the plan.
          </Text>
        ))}
        <View style={styles.shareAppTaskDetailsView}>
          <Image
            // @ts-expect-error TS(2769): No overload matches this call.
            style={styles.shareAppTaskDetailsImage}
            resizeMode="contain"
            source={shareapp}
            {...testProperties(DownlineProfile.cjTaskDetailsImage)}
          />
        </View>
      </View>
    </>
  );
};
